import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    name: yup
      .string()
      .trim()
      .required('Name is required')
      .min(1, 'Name must be at least 1 character'),
    param: yup
      .string()
      .trim()
      .required('Parameter is required')
      .min(1, 'Parameter must be at least 1 character'),
    select_all_label: yup
      .string()
      .trim()
      .nullable()
      .max(255, 'Select All Options Label must be at most 255 characters'),
    select_all_value: yup
      .string()
      .trim()
      .nullable()
      .max(255, 'Select All Options Value must be at most 255 characters'),
    is_multi: yup
      .boolean(),
      sync: yup.boolean().default(false),
    syncType: yup
      .object()
      .nullable()
      .when('sync', {
        is: true,
        then: (s) => s.required('Sync Type is required'),
        otherwise: (s) => s.nullable(true),
      }),
    connection: yup
      .object()
      .nullable()
      .when('sync', {
        is: true,
        then: (s) => s.required('Connection is required'),
        otherwise: (s) => s.nullable(true),
      }),
    table_name: yup
      .string()
      .transform((v, orig) => (orig === '' ? undefined : v))
      .trim()
      .nullable()
      .when('sync', {
        is: true,
        then: (s) => s.required('Table Name is required').min(1, 'Table Name is required'),
        otherwise: (s) => s.trim().notRequired(),
      }),
  })
  .required()

const resAddFilter = yupResolver(schema)

export default resAddFilter
